import React from 'react';
import * as EptaiAppComponents from '@eptai/eptai-app-components';
import { Navigate } from 'react-router';
import { LoadingState } from '@eptai/eptai-app-components';
import { useFeatureFlags } from '../../contexts';

type FeatureFlagGuardProps = {
  flagKey: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  loadingFallback?: React.ReactNode;
  redirectTo?: string;
};

export default function FeatureFlagGuard({
  flagKey,
  children,
  fallback = null,
  loadingFallback,
  redirectTo,
}: FeatureFlagGuardProps): React.JSX.Element | null {
  const { hasFlag, isLoading } = useFeatureFlags();
  const SharedFeatureFlagGuard = (EptaiAppComponents as { FeatureFlagGuard?: React.FC<any> })
    .FeatureFlagGuard;

  if (SharedFeatureFlagGuard) {
    return (
      <SharedFeatureFlagGuard
        flagKey={flagKey}
        hasFlag={hasFlag}
        isLoading={isLoading}
        fallback={fallback}
        loadingFallback={loadingFallback}
        redirectTo={redirectTo}
      >
        {children}
      </SharedFeatureFlagGuard>
    );
  }

  if (isLoading) {
    if (loadingFallback !== undefined) {
      return <>{loadingFallback}</>;
    }

    return <LoadingState variant="spinner" text="Loading feature access..." />;
  }

  if (!hasFlag(flagKey)) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }

    return <>{fallback}</>;
  }

  return <>{children}</>;
}
